import script from "./ShowcaseSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowcaseSection.vue?vue&type=script&setup=true&lang=js"

import "./ShowcaseSection.vue?vue&type=style&index=0&id=a3c7654c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3c7654c"]])

export default __exports__